let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8F5wz")).then(() => parcelRequire('7IFni'));